export default {
  fetchFilters(state, filters) {
    state.filters.list = filters;
  },

  setFilters(state, { category, filters }) {
    if (category) {
      filters.forEach(f => {
        const filter = state.filters[category].statFilters.find(
          item => item.key === f.key
        );
        if (filter) filter.status = f.status;
        else state.filters[category].statFilters.push(f);
      });
    } else {
      Object.keys(filters).forEach(key => {
        let k = filters[key];
        state.filters[k].statFilters = filters[key].filters;
      });
    }
    state.filters[category].isDefault = false;
  },
  setFilterSettings(state, { category, filters }) {
    if (category) state.filters[category].settings.list = filters;
    else {
      Object.keys(filters).forEach(key => {
        let k = filters[key];
        state.filters[k].settings.list = filters[key].filters;
      });
    }
  },
  filterLoading(state, status) {
    state.filters.isLoading = status;
  },
  closeFilters(state, value) {
    state.filters.isClosed = value;
  }
};
